// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard-module__card--cJ6MU","icon":"FeatureCard-module__icon--z251f","description":"FeatureCard-module__description--MqXWV"};